/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react';
import {Row, Col, Box, Pagination} from 'adminlte-2-react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {
  etapas,
  getDateOrEmpty,
  getDateWithFormat,
  toTitleCase,
} from '../utils/utils';
import Loader from '../utils/Loader';
import {log} from '../utils/logs';
import {etapasDescById} from '../utils/constants';
import {constants, getDateUtcOrEmpty, responseSelector} from '../utils/utils';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {alertTypes, useAlerts} from '../ui/alert';
import {produccionNotasGetDuck, produccionNotasGetThunk} from './duck';
import {useQueryParams} from '../utils/useQueryParams';
import {SelectInput} from '../utils/SelectInput';
import {useWindowSize} from '../utils/useWindowSize';

const etapasOptions = [
  {value: 'todas', label: 'Todas'},
  {value: 'reclutamiento', label: 'Reclutamiento'},
  {value: 'primerFiltro', label: 'Primer Filtro'},
  {value: 'entrevista', label: 'Entrevista'},
  {value: 'entrevistaDirector', label: 'Entrevista Director'},
  {value: 'entrevistaCliente', label: 'Entrevista Cliente'},
  {value: 'cierre', label: 'Cierre'},
];

const etapasIdsByName = {
  todas: null,
  reclutamiento: [200, 300],
  primerFiltro: [201, 301],
  entrevista: [202, 203, 302],
  entrevistaDirector: [204, 304],
  entrevistaCliente: [205, 305],
  cierre: [206, 306],
};

export const NotasSection = ({history, token}) => {
  log('NotasTable.render');

  const dispatch = useDispatch();

  const {width} = useWindowSize();

  const {queryParams, queryParamsloaded} = useQueryParams(history);

  const produccionNotasGet = useSelector(state => state.produccionNotasGet);

  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [groupedNotas, setGroupedNotas] = useState({});
  const [etapaOption, setEtapaOption] = useState(etapasOptions[0]);

  const {setTopAlert, topAlert} = useAlerts();

  const dispatchGetNotas = params => {
    dispatch(produccionNotasGetThunk(params));
  };

  useEffect(() => {
    if (!queryParamsloaded) {
      return;
    }

    handlePage();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, queryParamsloaded, etapaOption]);

  useEffect(() => {
    const {data, httpStatus, error, errorMessage} =
      responseSelector(produccionNotasGet);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(produccionNotasGetDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      setGroupedNotas(data.groupedItems);
      setTotalResults(data.total);
      dispatch(produccionNotasGetDuck.actions.clear());
    }
  }, [produccionNotasGet]);

  const handlePage = (page = 0) => {
    setTopAlert({
      title: '',
      text: '',
      type: alertTypes.danger,
      closable: false,
    });

    setActivePage(page);

    const params = {
      userToken: token.raw,
      page: page + 1,
      limit: pageSize,
      selectorId: queryParams.selectorId,
      equipoId: queryParams.equipoId,
      fechaInicio: getDateUtcOrEmpty(queryParams.fechaInicio),
      fechaFin: getDateUtcOrEmpty(queryParams.fechaFin),
      etapas: etapasIdsByName[etapaOption.value],
    };

    dispatchGetNotas(params);
  };

  if (produccionNotasGet.loading) {
    return <Loader isLoading />;
  }

  return (
    <Box title="Notas">
      <Row>
        <Col xs="12" sm="6">
          <div style={{display: 'block'}}>
            <span>Total: {totalResults}</span>
          </div>
          <Pagination
            activePage={activePage}
            pageSize={pageSize}
            totalElements={totalResults}
            onChange={handlePage}
            labels={{
              first: 'Primera',
              last: 'Última',
              previous: 'Anterior',
              next: 'Siguiente',
            }}
          />
        </Col>
        <Col xs="12" sm="6">
          <div
            style={{
              display: 'flex',
              justifyContent: width < 768 ? 'flex-start' : 'flex-end',
            }}>
            <div style={{minWidth: 300}}>
              <SelectInput
                label="Etapa"
                value={etapaOption}
                options={etapasOptions}
                setValue={setEtapaOption}
                isLoading={produccionNotasGet.loading}
              />
            </div>
          </div>
        </Col>
      </Row>

      {Object.entries(groupedNotas).map(([etapaId, group]) => (
        <div key={etapaId}>
          <b>Etapa: {etapasDescById[etapaId] ?? 'Sin Etapa'}</b>
          <Box noPadding={true} border={false} style={{borderTop: 0}}>
            <div className="table-responsive">
              <DataTable
                lazy
                pt={{
                  table: {
                    className: 'table table-hover',
                  },
                }}
                value={group.notas}
                emptyMessage="No se encontraron registros">
                <Column
                  field="candidato"
                  header="Candidato"
                  body={nota => (
                    <div style={{minWidth: 100}}>
                      {toTitleCase(nota.candidatoNombre)}
                    </div>
                  )}
                />

                <Column
                  field="oportunidad"
                  header="Oportunidad"
                  body={nota => {
                    if (!nota.oportunidadId) {
                      return <div style={{minWidth: 150}}>Sin oportunidad</div>;
                    }
                    return (
                      <div style={{minWidth: 150}}>
                        {toTitleCase(nota.oportunidadNombre)}
                      </div>
                    );
                  }}
                />

                <Column
                  field="titulo"
                  header="Título"
                  body={nota => (
                    <div style={{minWidth: 150}}>
                      {nota.noListable ? (
                        <small className="label bg-blue">Copia</small>
                      ) : null}{' '}
                      {toTitleCase(nota.titulo)}
                    </div>
                  )}
                />

                <Column
                  field="contenido"
                  header="Contenido"
                  style={{minWidth: 150}}
                />

                <Column
                  header="Fecha producción"
                  body={nota => (
                    <div style={{minWidth: 70}}>
                      {getDateOrEmpty(nota.produccionFecha)}
                    </div>
                  )}></Column>

                <Column
                  header="Fecha creación"
                  body={nota => (
                    <div style={{minWidth: 120}}>
                      {getDateWithFormat(nota.creacionTs, 'YYYY-MM-DD HH:mm')}
                      <br />
                      <small>
                        por: {nota.creacionUsuarioNombre}
                        <br />
                        {nota.companheroId
                          ? `Con superv.: ${nota.companheroNombre}`
                          : ''}
                      </small>
                    </div>
                  )}></Column>
              </DataTable>
            </div>
          </Box>
        </div>
      ))}
      <Pagination
        activePage={activePage}
        pageSize={pageSize}
        totalElements={totalResults}
        onChange={handlePage}
        labels={{
          first: 'Primera',
          last: 'Última',
          previous: 'Anterior',
          next: 'Siguiente',
        }}
      />
      <div style={{display: 'block'}}>
        <span>Total: {totalResults}</span>
      </div>
    </Box>
  );
};
